import React, { Component } from 'react'
import { aDates } from 'utils/aUtils'
import DataSyncTable from 'components/dataSyncTable'
import DataTable from 'components/dataTable'

export default class SpecialDateTable extends Component {

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const CellType = DataTable.CellType
    // const map = { true: '補班日', false: '假日' }
    const map = {
      true: '工作日',
      false: '國定假日',
      leave: '例假日',
      dayoff: '休息日',
    }
    const schemas = [
      { type: CellType.date, title: '日期', key: 'date', width: '8em' },
      { type: CellType.input, title: '名稱', key: 'name', width: '13em' },
      { type: CellType.dropDown, title: '類型', key: 'isWorking', width: '6em', map },
    ]

    return (
      <DataSyncTable
        dataUtil={aDates}
        schemas={schemas}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/specialDateTable.jsx